import type { SerializeFrom } from '@remix-run/node';
import { richTextToHTML } from '@theprintbar/shared';
import type { loader } from '../_index';

export function getFAQStructuredData(data?: SerializeFrom<typeof loader>) {
	return {
		'script:ld+json': {
			'@context': 'https://schema.org',
			'@type': 'FAQPage',
			mainEntity: data?.contentPage.articles?.map(article => ({
				'@type': 'Question',
				name: article.title,
				acceptedAnswer: {
					'@type': 'Answer',
					text: richTextToHTML(article.content),
				},
			})),
		},
	};
}
